<template>
  <div class="d-flex align-center justify-center" :style="{minHeight: minHeight}">
    <v-progress-circular indeterminate size="64" color="primary"/>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * Carregamento de dentro de um modal. Numa página a barra fininha do ontos-base
 * basta; num modal ela deixa uma janela vazia com um fiapo no topo.
 *
 * Spinner como conteúdo do card, e não v-overlay: o overlay nasce em z-index 5 e o
 * conteúdo do v-dialog fica por volta de 202, então ele apareceria atrás do modal.
 * O min-height é o que impede a janela de nascer espremida e dar salto quando o
 * conteúdo entra.
 */
@Component({
  name: 'ontos-dialog-loading'
})
class DialogLoading extends Vue {
  @Prop({type: String, default: '240px'}) readonly minHeight!: string
}

export default toNative(DialogLoading)
</script>
